import aframe from "aframe"

aframe.registerComponent('control-box', {
    schema: {
        
        offset: {
            type: "number",
            default: -5.0, //-30.0
        },

        enableX: {
            type: "boolean",
            default: true,
        },

        doubleX: {
            type: "boolean",
            default: false,
        },

        offsetY: {
            type: "number",
            default: 25,
        },

        enableY: {
            type: "boolean",
            default: true,
        }
    },

    init: function () {
        this.moving = false
        // this.enableFixed()

        console.log("Control Box Enable");

        this.camDeltaY = 0

        this.onCameraChangeBinded = this.onCameraChange.bind(this)

        this.camera = document.getElementById('camera')

        const rot = this.el.getAttribute("rotation")
        this.el.setAttribute("rotation", {
            ...rot,
            x: (this.data.enableX) ? this.camera.getAttribute("rotation").x : 0,
            y: (this.data.enableY) ? this.camera.getAttribute("rotation").y : 0,
        })

        this.camera.addEventListener('componentchanged', this.onCameraChangeBinded)
    },
    
    remove: function() {
        this.camera.removeEventListener('componentchanged', this.onCameraChangeBinded);
    },

    enableFixed: function () {

        if (!this.moving) {
            this.el.setAttribute('fixed', {
                enabled: true,
                fixX: false,

                offsetY: (this.camDelta > 0) ? -this.camDelta : this.camDelta,
            })
            this.moving = true;
        }
    },

    disableFixed: function () {
        if (this.moving) {
            this.el.setAttribute('fixed', {
                enabled: false
            })
            this.moving = false; 
        }
    },

    onCameraChange: function(e) {

        if (e.detail.name !== 'rotation') {
            return
        }

        const rot = this.el.getAttribute("rotation")

        let cameraAngleX = e.detail.newData.x
        this.camY = e.detail.newData.y
        this.camX = e.detail.newData.x

        this.camDeltaY = e.detail.newData.y - rot.y
        this.camDeltaX = e.detail.newData.x - rot.x

        if (cameraAngleX > this.data.offset && this.data.enableX) {

            this.el.setAttribute("rotation", {
                ...rot,
                y: this.camY
            })
        
        } else if ( Math.abs(this.camDeltaX) > this.data.offset && this.data.doubleX ) {

            this.el.setAttribute("rotation", {
                ...rot,
                x: this.camX + Math.abs(this.camDeltaX) / this.camDeltaX * this.data.offset * (-1)
            })

        } else if ( Math.abs(this.camDeltaY) > this.data.offsetY && this.data.enableY ) {

            this.el.setAttribute("rotation", {
                ...rot,
                y: this.camY + Math.abs(this.camDeltaY) / this.camDeltaY * this.data.offsetY * (-1)
            })

        } 
    }
})


// WEBPACK FOOTER //
// ./src/components-aframe/controlBox.js